// extracted by mini-css-extract-plugin
export default {"header":"PopupFullWidthOnMobile_header__0zvlb","content":"PopupFullWidthOnMobile_content__+mAJI","divider":"PopupFullWidthOnMobile_divider__518tr"};